import React, { useState, useEffect } from "react";
import { Alert, Box, useMediaQuery, useTheme } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { toast, Zoom } from "react-toastify";
import SideBar from "./SideBar";
import ChatContainer from "./ChatContainer";
import NoChatSelected from "./skeletons/NoChatSelected";
import NoSubscribe from "../NoSubscribe";
import { getMembership } from "../../api/api";
import { useAuthStore } from "./store/useAuthStore";
import { useChatStore } from "./store/useChatStore";

const CustomChat = () => {
  const { selectedUser, setSelectedUser, error } = useChatStore();
  const { connectionError } = useAuthStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [membership, setMembership] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkSubscription();
  }, []);

  const checkSubscription = async () => {
    setIsLoading(true);
    try {
      const response = await getMembership();
      if (response && response.status >= 200 && response.status <= 300) {
        setMembership(response?.data?.is_membership);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!membership) {
    return <NoSubscribe />;
  }

  // One pane at a time on mobile: the list until a conversation is opened.
  const showList = !isMobile || !selectedUser;
  const showThread = !isMobile || Boolean(selectedUser);

  return (
    <Box
      height={"100%"}
      display={"flex"}
      flexDirection={"column"}
      minHeight={0}
      overflow={"hidden"}
      border={"1px solid #ececec"}
      borderRadius={2}
      bgcolor={"#fff"}
    >
      {(connectionError || error) && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {connectionError || error}
        </Alert>
      )}

      <Box display={"flex"} flex={1} minHeight={0}>
        {showList && (
          <Box
            width={{ xs: "100%", md: 320, lg: 360 }}
            flexShrink={0}
            minHeight={0}
            borderRight={{ xs: "none", md: "1px solid #ececec" }}
          >
            <SideBar />
          </Box>
        )}

        {showThread && (
          <Box flex={1} minWidth={0} minHeight={0}>
            {selectedUser ? (
              <ChatContainer
                onBack={isMobile ? () => setSelectedUser(null) : undefined}
              />
            ) : (
              <NoChatSelected />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CustomChat;
